(function () {
    'use strict';

    // @ngInject
    function CreditCardConfirmControllerCtor($scope, $injector, AnalyticsService, $translate, $modalInstance, UsersManager, PopupMessageService, card, $timeout, DeviceService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CreditCardConfirmController';
        AnalyticsService.trackPageView(this, 'CreditCardConfirmView');

        this.card = card;
        this.modalInstance = $modalInstance;
        this.$translate = $translate;
        this.AnalyticsService = AnalyticsService;
        this.UsersManager = UsersManager;
        this.PopupMessageService = PopupMessageService;
        this.$timeout = $timeout;
        this.isTouchDevice = DeviceService.checkIfTouchDevice();
    }

    Controllers.CreditCardConfirmController = Class(Controllers.BaseController, {
        constructor: CreditCardConfirmControllerCtor,

        creditCardValidationConfirm: function creditCardValidationConfirm() {
            if (!this.expMonth || !this.expYear) {
                this.errorMessage = this.$translate.instant('FILE.PAYMENT.CARD_CONFIRM._PLEASE_ENTER_EXP_DATE_');
                return;
            }

            var month = this.expMonth;
            var year = parseInt(this.expYear) + 2000; // This will crash when will get to the 3000s, someone should fix it by then

            this.validateCardExpirationDate(this.card._id, month, year).then(function(resp) {
                this._setValidation(resp.data);

                if (this.creditCardConfirmForm.$valid){
                    this.modalInstance.close({valid: true});
                }
            }.bind(this)).catch(function fail() {
                this.PopupMessageService.showAlertPromise(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._TRY_AGAIN_');
            }.bind(this));
        },

        validateCardExpirationDate: function validateCardExpirationDate(paymentMethodId, month, year) {
            return this.UsersManager.validateCardExpirationDate(paymentMethodId, month, year);
        },

        _setValidation: function _setValidation(val) {
            this.creditCardConfirmForm.$setValidity('cardConfirmation', val);
            this.errorMessage = !val ? this.$translate.instant('FILE.PAYMENT.CARD_CONFIRM._INCORRECT_TRY_AGAIN_') : '';
        },

        addAnotherCard: function addAnotherCard() {
            this.modalInstance.close({addNewCard: true});
        },

        dismiss: function dismiss(triggerSource) {
            this.modalInstance.dismiss();

            if (triggerSource) {
                this._analyticsClickOutside();
            }
        },

        _analyticsClickOutside: function _analyticsClickOutside() {
            var params = {
                source: 'credit card confirm modal',
                secondarySource: 'click outside'
            };
            this.AnalyticsService.trackClick(this, 'collapse credit card confirm modal', params);
        },

        fieldSettings: function fieldSettings($event) {
            $event.target.id === "expMonth" ? this._validator($event, 2, '#expYear') : this._validator($event, 2, '');
        },

        _validator: function _validator($event, chartMaxLength, nextFocusElem) {
            var key = $event.keyCode ? $event.keyCode : $event.which;

            if (key !== 8 && key !== 46) {
                if ($event.target.value.length >= chartMaxLength) {
                    $event.preventDefault();
                }

                if ( !this.isTouchDevice ) {
                    if (nextFocusElem && $event.target.value.length >= (chartMaxLength - 1)) {
                        this.$timeout(function() {
                            angular.element(nextFocusElem).focus();
                        });
                    }
                }

                if ( isNaN( String.fromCharCode(key) ) ){
                    $event.preventDefault();
                }
            }
        },
    });
}());
